import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { collection, addDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { query, where, getDocs } from "firebase/firestore";
import LanguageToggle from "./LanguageToggle";

export default function HomePage() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [showTypeSelector, setShowTypeSelector] = useState(false);
  const [docId, setDocId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const [officerId, setOfficerId] = useState(null);
  const [officerInfo, setOfficerInfo] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const officer = params.get("officerId");
    console.log("Referral param from URL:", officer);
    if (officer) setOfficerId(officer);
  }, [location]);

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    if (officerId) {
      const fetchOfficer = async () => {
        const officerDoc = await getDoc(doc(db, "officers", officerId));
        if (officerDoc.exists()) {
          setOfficerInfo(officerDoc.data());
        } else {
          setOfficerInfo(null);
        }
      };
      fetchOfficer();
    }
  }, [officerId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");

    try {
      // ✅ Query top-level email field to avoid nested field query issue
      const emailToCheck = formData.email;

      const q = query(
        collection(db, "clients"),
        where("email", "==", emailToCheck)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setSuccess("❌ Este correo electrónico ya está registrado.");
        setLoading(false);
        return;
      }

      // ✅ Add new document with top-level email field for future queries
      const docRef = await addDoc(collection(db, "clients"), {
        email: emailToCheck,
        formDataPurchase: { ...formData },
        formDataRefinance: { ...formData },
        assignedOfficer: officerId || null,
        createdAt: new Date(),
        currentStep: 1,
      });

      // ✅ Local state & navigation
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("clientInfo", JSON.stringify(formData));
      localStorage.setItem("clientDocId", docRef.id);

      setSuccess(
        `🎉 Cuenta creada: ${formData.firstName} ${formData.lastName}`
      );
      setDocId(docRef.id);
      setShowTypeSelector(true);
    } catch (error) {
      console.error("❌ Firebase error:", error);
      setSuccess("❌ Por favor intente de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const handleTransactionTypeSelect = async (type) => {
    try {
      const ref = doc(db, "clients", docId);
      await updateDoc(ref, { transactionType: type });
      navigate(
        type === "Purchase"
          ? `/es/questions?id=${docId}`
          : `/es/refinance?id=${docId}`
      );
    } catch (err) {
      console.error("Error setting transaction type:", err);
    }
  };

  const buttonStyle = {
    backgroundColor: "#0098BA",
    color: "white",
    padding: "0.75rem",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "600",
    transition: "background-color 0.3s ease",
  };

  const buttonHoverStyle = {
    backgroundColor: "#3AB09E",
  };

  const inputStyle = {
    padding: "0.75rem",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "1rem",
    transition: "border-color 0.3s ease, box-shadow 0.3s ease",
    outline: "none",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  };

  function formatPhone(phone) {
    if (!phone) return "";
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 10) {
      return `(${cleaned.substr(0, 3)}) ${cleaned.substr(
        3,
        3
      )}-${cleaned.substr(6, 4)}`;
    }
    return phone;
  }

  return (
    <main
      style={{
        padding: "2vw",
        textAlign: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <div style={{ position: "absolute", top: 16, right: 16, zIndex: 10 }}>
        <LanguageToggle />
      </div>
      <div style={{ marginBottom: "2rem" }}>
        <img
          src="/HMB2.png"
          alt="Home Mortgage Bankers Logo"
          style={{
            width: "450px",
            maxWidth: "90vw",
            height: "auto",
            objectFit: "contain",
            display: "block",
            margin: "0 auto",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        />
        <h1
          style={{
            fontSize: "2.25rem",
            margin: "1rem 0 0.5rem",
            color: "#222",
            wordBreak: "break-word",
          }}
        >
          Home Mortgage Bankers "Pre-Qual"
        </h1>
        <p style={{ color: "#555", fontSize: "1.1rem" }}>
          Tu forma rapida de precalificar para un prestamo hipotecario.
        </p>
      </div>

      {officerId && (
        <div
          style={{
            background: "#e0f7fa",
            color: "#0096b2",
            padding: 10,
            borderRadius: 6,
            marginBottom: 10,
            fontWeight: "bold",
            fontSize: "1rem",
            wordBreak: "break-word",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 340,
              textAlign: "left",
              fontWeight: 700,
              color: "#007bff",
              marginBottom: 2,
              paddingLeft: 8,
              paddingRight: 8,
              boxSizing: "border-box",
            }}
          >
            {officerInfo?.name ? `${officerInfo.name}` : officerId}
            {officerInfo?.mloNumber && ` ( ${officerInfo.mloNumber})`}
          </div>
          {officerInfo?.phone && (
            <div
              style={{
                width: "100%",
                maxWidth: 340,
                textAlign: "left",
                color: "#222",
                fontWeight: 700,
                fontSize: "1.07em",
                marginTop: 2,
                paddingLeft: 28,
                boxSizing: "border-box",
              }}
            >
              {formatPhone(officerInfo.phone)}
            </div>
          )}
        </div>
      )}

      {!showTypeSelector && (
        <form
          onSubmit={handleSubmit}
          style={{
            maxWidth: "400px",
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            background: "#fff",
            padding: "1.2rem",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <input
            type="text"
            name="firstName"
            placeholder="Nombre"
            required
            value={formData.firstName}
            onChange={handleChange}
            style={inputStyle}
          />
          <input
            type="text"
            name="lastName"
            placeholder="Apellidos"
            required
            value={formData.lastName}
            onChange={handleChange}
            style={inputStyle}
          />
          <input
            type="email"
            name="email"
            placeholder="Correo Electrónico"
            required
            value={formData.email}
            onChange={handleChange}
            style={inputStyle}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Teléfono"
            required
            value={formData.phone}
            onChange={handleChange}
            style={inputStyle}
          />
          <input
            type="password"
            name="password"
            placeholder="Contraseña"
            required
            value={formData.password}
            onChange={handleChange}
            style={inputStyle}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              ...buttonStyle,
              opacity: loading ? 0.6 : 1,
              cursor: loading ? "not-allowed" : "pointer",
              width: "100%",
              marginTop: 8,
            }}
            onMouseOver={(e) => {
              if (!loading)
                e.currentTarget.style.backgroundColor =
                  buttonHoverStyle.backgroundColor;
            }}
            onMouseOut={(e) => {
              if (!loading)
                e.currentTarget.style.backgroundColor =
                  buttonStyle.backgroundColor;
            }}
          >
            {loading ? "Inscribiendo..." : "Inscríbete"}
          </button>
          <a
            href="/es/login"
            style={{
              display: "inline-block",
              textAlign: "center",
              backgroundColor: buttonStyle.backgroundColor,
              color: buttonStyle.color,
              padding: buttonStyle.padding,
              borderRadius: buttonStyle.borderRadius,
              textDecoration: "none",
              marginTop: "0.5rem",
              fontSize: "1rem",
              fontWeight: "600",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor =
                buttonHoverStyle.backgroundColor)
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor =
                buttonStyle.backgroundColor)
            }
          >
            Conéctate
          </a>
          {success && (
            <p style={{ marginTop: "1rem", color: "green", fontWeight: "500" }}>
              {success}
            </p>
          )}
        </form>
      )}

      {showTypeSelector && (
        <div
          style={{
            marginTop: "2rem",
            padding: "1.2rem",
            background: "#fff",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            maxWidth: "400px",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <h2
            style={{
              color: "#0096b2",
              marginBottom: "2rem",
              fontSize: "1.5rem",
            }}
          >
            Selecciona tu transacción:
          </h2>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              gap: "1rem",
            }}
          >
            <button
              onClick={() => handleTransactionTypeSelect("Purchase")}
              style={{
                width: "40vw",
                maxWidth: "140px",
                minWidth: "100px",
                height: "40vw",
                maxHeight: "140px",
                minHeight: "100px",
                borderRadius: "50%",
                fontSize: "1.1rem",
                fontWeight: "bold",
                border: "none",
                backgroundColor: "#0096b2",
                color: "white",
                cursor: "pointer",
              }}
            >
              Comprar
            </button>
            <button
              onClick={() => handleTransactionTypeSelect("Refinance")}
              style={{
                width: "40vw",
                maxWidth: "140px",
                minWidth: "100px",
                height: "40vw",
                maxHeight: "140px",
                minHeight: "100px",
                borderRadius: "50%",
                fontSize: "1.1rem",
                fontWeight: "bold",
                border: "none",
                backgroundColor: "#005c78",
                color: "white",
                cursor: "pointer",
              }}
            >
              Refinanciar
            </button>
          </div>
        </div>
      )}

      <div style={{ marginTop: "2rem" }}>
        <h3 style={{ fontSize: "1.25rem", color: "#333" }}>Contáctanos</h3>
        <p style={{ color: "#555", fontSize: "0.98rem" }}>
          Marginal Santa Rosa Bloq 51 #55 Local #2, Bayamón PR 00956
          <br />
          Tel. 787-785-6500. Equal Housing Opportunity Lender LIC IH 110
        </p>
      </div>

      {/* Responsive tweaks for button stacking */}
      <style>
        {`
        @media (max-width: 600px) {
          form, .selectorBox {
            padding: 1rem !important;
          }
          h1 {
            font-size: 1.5rem !important;
          }
          .selectorBox > div {
            flex-direction: column !important;
            gap: 1rem !important;
          }
        }
      `}
      </style>
    </main>
  );
}
